import comp from "./MarkdownView";
export default comp;
